import Navbar from "../../components/Navbar";
import "../../pages/itinerary/css/itinerary.css"
import "./css/transportation.css"
import {AfterCocktailEntries, FromHotelEntries, ToHotelsEntries, AfterWeddingEntries} from "../../data/Transportation";
import Footer from "../../components/Footer";

const Transportation = () => {
    return (
        <main>
            <Navbar/>

            <div className="container itinerary__container">
                <div className="itinerary__header">
                    <h1 className="text-cursive">Transportation</h1>
                </div>

                <hr/>

                <h1 className="transport__section-title">Shuttle to Reception</h1>

                <div className="container itinerary__schedule">
                    {
                        FromHotelEntries.map((entry) => {
                            return (
                                <>
                                    <div key={entry.id} className="itinerary__schedule-row">
                                        <div className="itinerary__schedule-col1">
                                            <h3>{entry.time}</h3>
                                        </div>
                                        <div className="itinerary__schedule-col2">
                                            <h3>{entry.title}</h3>
                                            {entry.description != null && <h4>{entry.description}</h4>}
                                        </div>
                                    </div>
                                    <hr/>
                                </>
                            )
                        })
                    }
                </div>

                <h2 className="transport__note">Cocktail hour begins at 4pm.</h2>

                <div className="container itinerary__schedule">
                    {
                        AfterCocktailEntries.map((entry) => {
                            return (
                                <>
                                    <div key={entry.id} className="itinerary__schedule-row">
                                        <div className="itinerary__schedule-col1">
                                            <h3>{entry.time}</h3>
                                        </div>
                                        <div className="itinerary__schedule-col2">
                                            <h3>{entry.title}</h3>
                                            {entry.description != null && <h4>{entry.description}</h4>}
                                        </div>
                                    </div>
                                    <hr/>
                                </>
                            )
                        })
                    }
                </div>

                <h1 className="transport__section-title">Shuttle to Hotels</h1>

                <div className="container itinerary__schedule">
                    {
                        ToHotelsEntries.map((entry) => {
                            return (
                                <>
                                    <div key={entry.id} className="itinerary__schedule-row">
                                        <div className="itinerary__schedule-col1">
                                            <h3>{entry.time}</h3>
                                        </div>
                                        <div className="itinerary__schedule-col2">
                                            <h3>{entry.title}</h3>
                                            {entry.description != null && <h4>{entry.description}</h4>}
                                        </div>
                                    </div>
                                    <hr/>
                                </>
                            )
                        })
                    }
                </div>

                <h2 className="transport__note">Wedding ends at 10pm.</h2>

                <div className="container itinerary__schedule">
                    {
                        AfterWeddingEntries.map((entry) => {
                            return (
                                <>
                                    <div key={entry.id} className="itinerary__schedule-row">
                                        <div className="itinerary__schedule-col1">
                                            <h3>{entry.time}</h3>
                                        </div>
                                        <div className="itinerary__schedule-col2">
                                            <h3>{entry.title}</h3>
                                            {entry.description != null && <h4>{entry.description}</h4>}
                                        </div>
                                    </div>
                                    <hr/>
                                </>
                            )
                        })
                    }
                </div>

                <h2 className="transport__note">Shuttles will leave promptly at the pick up times listed. Please plan on being outside a few minutes prior to pickup time to ensure you do not miss the shuttle.</h2>
                <h2 className="transport__note">Shuttle capacity is 25 people. If you are unable to fit on the first shuttle, please wait for the next shuttle to arrive.</h2>
            </div>
            <Footer/>
        </main>
    );
};

export default Transportation;
